import React, { useState, useEffect } from 'react';
import State from "../State";
import PageService  from "./PageService";
import './Page.css';
import ClipLoader from "react-spinners/ClipLoader";
import ReactMarkdown from 'react-markdown'

function PM({jsonServer}) {
    const [state] = useState(new State(useState(0)));

    const service = new PageService(jsonServer, state);

    useEffect(() => {
        service.fetchPage('pm');
    }, []);

    if (state.errorMsg) {
        return (<span className="errorMessage">{state.errorMsg}</span>);
    }

    if (state.loading || state.page === null) {
        return (
            <div>
                <ClipLoader loading={state.loading} size={150} />
            </div>
        );
    }

    return (
        <>
            <div>
                <h1>{state.page.headline}</h1>
                <span style={{color:'red'}}>{state.page.preamble}</span>

                {
                    state.page.snippets.map((a) => {
                        return (
                            <div key={a.id}>
                                <h3>{a.headline}</h3>
                                <ReactMarkdown>{a.content}</ReactMarkdown>
                            </div>
                        )
                    })
                }

            </div>
        </>
    );
}

export default PM;